import { ArrowUpOutlined, CheckCircleFilled, MinusCircleOutlined, PlusOutlined, PoweroffOutlined } from "@ant-design/icons";
import { Popconfirm, Table, Tooltip } from "antd";
import React, { Component } from "react";
import { ButtonItem, SelectItem, TagItem } from "../../../Components/Items";
import { colorPaleta } from "../../../Components/TagItem";

export const dinero = (valor) => Number(valor || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN" });

const ACENTO = colorPaleta("cyan");

export const Indicador = ({ titulo, valor, color = ACENTO, chico }) => (
    <div
        style={{
            flex: "1 1 170px",
            minWidth: 170,
            background: "white",
            border: "1px solid #f0f0f0",
            borderLeft: `4px solid ${color}`,
            borderRadius: 8,
            padding: "8px 14px",
        }}
    >
        <div style={{ fontSize: 12, color: "#8c8c8c" }}>{titulo}</div>
        <div style={{ fontSize: chico ? 15 : 20, fontWeight: 600, color: "#262626", lineHeight: chico ? "30px" : undefined }}>{valor}</div>
    </div>
);

export const TituloSeccion = ({ children, style }) => <div style={{ fontWeight: 600, fontSize: 14, color: "#333", margin: "0 0 8px", ...style }}>{children}</div>;

class PlanEmpresa extends Component {
    state = { paquetesElegidos: {} };

    precioDe = (modulo, nivelId) =>
        modulo.concepto?.tipoPrecio === "niveles" ? modulo.concepto.niveles.find((n) => n._id === nivelId)?.precio : modulo.concepto?.precio;

    nombreNivel = (modulo) => modulo.concepto?.niveles?.find((n) => n._id === modulo.nivelId)?.nombre;

    modoLibre = () => !this.props.plan.cobroActivo && !!this.props.onCambiarModulo;

    filas() {
        const { empresa } = this.props;
        const combos = empresa.partidas.filter((p) => p.tipo === "combo");
        const sueltos = empresa.partidas.filter((p) => p.tipo === "concepto");
        const libre = this.modoLibre();
        return empresa.modulos
            .filter((m) => m.clave !== "claude" && (libre || m.activo || m.concepto))
            .map((modulo) => {
                const suelto = sueltos.find((p) => p.clave === modulo.clave);
                const combo = combos.find((p) => (p.claves || []).includes(modulo.clave));
                const detalleCombo = combo && (combo.detalle || []).find((d) => d.clave === modulo.clave);
                const excedente = empresa.partidas.find((p) => p.tipo === "excedente" && p.clave === modulo.clave);
                return { key: modulo.clave, modulo, suelto, combo, detalleCombo, excedente };
            })
            .sort((a, b) => Number(b.modulo.activo) - Number(a.modulo.activo));
    }

    renderPrecio(fila) {
        return (
            <>
                {this.renderPrecioBase(fila)}
                {fila.excedente && (
                    <div style={{ fontSize: 12, color: colorPaleta("naranjaOscuro") }}>
                        + {fila.excedente.cantidad} empleados adicionales: {dinero(fila.excedente.importe)} sin IVA
                    </div>
                )}
            </>
        );
    }

    renderPrecioBase(fila) {
        const { modulo, suelto, combo, detalleCombo } = fila;
        if (!modulo.activo) {
            if (!modulo.concepto) return "—";
            if (modulo.concepto.tipoPrecio === "niveles") {
                return <span style={{ color: "#8c8c8c" }}>Desde {dinero(Math.min(...modulo.concepto.niveles.map((n) => n.precio)))} sin IVA</span>;
            }
            return <span style={{ color: "#8c8c8c" }}>{dinero(modulo.concepto.precio)} sin IVA</span>;
        }
        if (combo)
            return (
                <>
                    <div>{detalleCombo ? `${dinero(detalleCombo.precioCompleto)} sin IVA` : "—"}</div>
                    <TagItem cyan style={{ marginTop: 4 }}>Combo {combo.nombre}</TagItem>
                </>
            );
        if (suelto)
            return (
                <>
                    <div>{dinero(suelto.importeCompleto)} sin IVA</div>
                    {suelto.dias && (
                        <div style={{ fontSize: 12, color: "#8c8c8c" }}>
                            Este periodo: {dinero(suelto.importe)} ({suelto.dias.cobrados} de {suelto.dias.periodo} días)
                        </div>
                    )}
                </>
            );
        return modulo.concepto ? <TagItem naranja>Activo, sin cobro</TagItem> : <TagItem gris>Incluido</TagItem>;
    }

    renderAcciones(fila) {
        const { empresa, plan, onEnviar } = this.props;
        const { paquetesElegidos } = this.state;
        const { modulo } = fila;
        if (!plan.cobroActivo || !modulo.concepto) return null;
        const conPaquetes = modulo.concepto.tipoPrecio === "niveles";
        const elegido = paquetesElegidos[modulo.clave];
        const elegir = (opciones) => (
            <SelectItem
                width={200}
                size="small"
                placeholder={modulo.activo ? "Subir de paquete" : "Elige el paquete"}
                value={elegido}
                onChange={(nivelId) => this.setState((s) => ({ paquetesElegidos: { ...s.paquetesElegidos, [modulo.clave]: nivelId } }))}
                options={opciones.map((n) => ({ value: n._id, label: `${n.nombre} · ${dinero(n.precio)}` }))}
            />
        );
        const contenedor = { display: "flex", gap: 8, alignItems: "center", justifyContent: "flex-end" };

        if (!modulo.activo) {
            const precio = conPaquetes ? this.precioDe(modulo, elegido) : modulo.concepto.precio;
            return (
                <div style={contenedor}>
                    {conPaquetes && elegir(modulo.concepto.niveles)}
                    {(!conPaquetes || elegido) && (
                        <Popconfirm
                            title={`¿Activar ${modulo.nombre} por ${dinero(precio)} sin IVA? Se cobra desde hoy`}
                            onConfirm={() => onEnviar("mejorarMiPlan", { empresaId: empresa._id, clave: modulo.clave, nivelId: elegido })}
                            okText="Sí"
                            cancelText="No"
                        >
                            <Tooltip title="Activar">
                                <ButtonItem verdeNatural size="small" icon={<PlusOutlined />} />
                            </Tooltip>
                        </Popconfirm>
                    )}
                </div>
            );
        }

        if (!conPaquetes) return null;
        const precioActual = this.precioDe(modulo, modulo.nivelId) || 0;
        const mejores = modulo.concepto.niveles.filter((n) => n.precio > precioActual);
        if (!mejores.length) return null;
        return (
            <div style={contenedor}>
                {elegir(mejores)}
                {elegido && (
                    <Popconfirm
                        title={`¿Subir ${modulo.nombre}? Pasa de ${dinero(precioActual)} a ${dinero(this.precioDe(modulo, elegido))} sin IVA y se cobra la diferencia desde hoy`}
                        onConfirm={() => onEnviar("mejorarMiPlan", { empresaId: empresa._id, clave: modulo.clave, nivelId: elegido })}
                        okText="Sí"
                        cancelText="No"
                    >
                        <Tooltip title="Subir de paquete">
                            <ButtonItem azul size="small" icon={<ArrowUpOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                )}
            </div>
        );
    }

    renderInterruptor(fila) {
        const { onCambiarModulo } = this.props;
        const { modulo } = fila;
        if (modulo.activo)
            return (
                <Popconfirm title={`¿Desactivar ${modulo.nombre}?`} onConfirm={() => onCambiarModulo(modulo.clave, false)} okText="Sí" cancelText="No">
                    <Tooltip title="Desactivar">
                        <ButtonItem rojo size="small" icon={<PoweroffOutlined />} />
                    </Tooltip>
                </Popconfirm>
            );
        return (
            <Tooltip title="Activar">
                <ButtonItem verdeNatural size="small" icon={<PlusOutlined />} onClick={() => onCambiarModulo(modulo.clave, true)} />
            </Tooltip>
        );
    }

    precioOrden = (fila) => {
        const { modulo, suelto, detalleCombo } = fila;
        if (!modulo.activo) {
            if (!modulo.concepto) return 0;
            return modulo.concepto.tipoPrecio === "niveles" ? Math.min(...modulo.concepto.niveles.map((n) => n.precio)) : modulo.concepto.precio || 0;
        }
        return (detalleCombo?.precioCompleto || suelto?.importeCompleto || 0) + (fila.excedente?.importe || 0);
    };

    columnas() {
        const { plan } = this.props;
        const libre = this.modoLibre();
        const filas = this.filas();
        const paquetes = [...new Set(filas.map((f) => (f.modulo.activo && this.nombreNivel(f.modulo)) || "—"))];
        const columnas = [
            {
                title: "Módulo",
                dataIndex: "modulo",
                filters: filas.map((f) => ({ text: f.modulo.nombre, value: f.modulo.clave })),
                onFilter: (valor, fila) => fila.modulo.clave === valor,
                render: (modulo) => (
                    <>
                        <div style={{ fontWeight: 600 }}>{modulo.nombre}</div>
                        {modulo.incluye?.length > 0 && <div style={{ fontSize: 12, color: "#8c8c8c" }}>Incluye: {modulo.incluye.join(", ")}</div>}
                    </>
                ),
            },
            {
                title: "Estado",
                width: 140,
                filters: [
                    { text: "Activado", value: true },
                    { text: "No activado", value: false },
                ],
                onFilter: (valor, fila) => !!fila.modulo.activo === valor,
                render: (_, fila) =>
                    fila.modulo.activo ? (
                        <TagItem verdeNatural icon={<CheckCircleFilled />}>
                            Activado
                        </TagItem>
                    ) : (
                        <TagItem gris icon={<MinusCircleOutlined />}>No activado</TagItem>
                    ),
            },
        ];
        if (libre) {
            columnas.push({
                title: "Acciones",
                key: "acciones",
                width: 100,
                align: "center",
                render: (_, fila) => <div style={{ display: "flex", justifyContent: "center" }}>{this.renderInterruptor(fila)}</div>,
            });
            return columnas;
        }
        columnas.push(
            {
                title: "Paquete",
                width: 140,
                filters: paquetes.map((p) => ({ text: p, value: p })),
                onFilter: (valor, fila) => ((fila.modulo.activo && this.nombreNivel(fila.modulo)) || "—") === valor,
                render: (_, fila) => (fila.modulo.activo ? this.nombreNivel(fila.modulo) || "—" : "—"),
            },
            { title: "Precio", width: 230, sorter: (a, b) => this.precioOrden(a) - this.precioOrden(b), render: (_, fila) => this.renderPrecio(fila) }
        );
        if (plan.cobroActivo) columnas.push({ title: "Acciones", key: "acciones", width: 280, align: "right", render: (_, fila) => this.renderAcciones(fila) });
        return columnas;
    }

    render() {
        const { empresa, plan, onEnviar } = this.props;
        const filas = this.filas();
        const combosAplicados = empresa.partidas.filter((p) => p.tipo === "combo").map((p) => String(p.comboId));
        const combosPorTomar = plan.combos.filter((k) => !combosAplicados.includes(String(k._id)));
        const total = empresa.partidas.reduce((s, p) => s + p.importe, 0);
        const activos = filas.filter((f) => f.modulo.activo).length;

        return (
            <>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
                    <TagItem cyan style={{ margin: 0, padding: "2px 10px", fontSize: 13 }}>
                        <b>{activos}</b> de {filas.length} módulos activados
                    </TagItem>
                    {!this.modoLibre() && (
                        <TagItem gris style={{ margin: 0, padding: "2px 10px", fontSize: 13 }}>
                            Este periodo: <b>{dinero(total)}</b> sin IVA
                        </TagItem>
                    )}
                </div>
                <Table
                    size="small"
                    className="custom-small-table"
                    pagination={false}
                    columns={this.columnas()}
                    dataSource={filas}
                    scroll={{ x: "max-content" }}
                    onRow={(fila) => ({ style: { background: fila.modulo.activo ? `${ACENTO}0D` : undefined } })}
                    locale={{ emptyText: "Sin módulos" }}
                />

                {plan.cobroActivo && combosPorTomar.length > 0 && (
                    <>
                        <TituloSeccion style={{ margin: "16px 0 8px" }}>Combos que puedes tomar</TituloSeccion>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                            {combosPorTomar.map((k) => (
                                <div
                                    key={k._id}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 6,
                                        flex: "1 1 260px",
                                        maxWidth: 340,
                                        background: "white",
                                        border: "1px solid #f0f0f0",
                                        borderLeft: `4px solid ${ACENTO}`,
                                        borderRadius: 8,
                                        padding: "10px 14px",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                                    }}
                                >
                                    <div style={{ fontWeight: 600 }}>{k.nombre}</div>
                                    <div style={{ fontSize: 12, color: "#595959" }}>{k.items.map((i) => `${i.nombre} (${dinero(i.precio)})`).join(" + ")}</div>
                                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 6 }}>
                                        <b>{dinero(k.precio)}</b>
                                        <span style={{ fontSize: 12, color: "#8c8c8c" }}>sin IVA</span>
                                        {k.precioSuelto > k.precio && <TagItem verdeNatural style={{ margin: 0 }}>Ahorras {dinero(k.precioSuelto - k.precio)}</TagItem>}
                                    </div>
                                    <div style={{ marginTop: "auto" }}>
                                        <Popconfirm
                                            title={`¿Tomar el combo ${k.nombre} por ${dinero(k.precio)} sin IVA? Se activan sus módulos y se cobra desde hoy`}
                                            onConfirm={() => onEnviar("tomarComboMiPlan", { empresaId: empresa._id, comboId: k._id })}
                                            okText="Sí"
                                            cancelText="No"
                                        >
                                            <ButtonItem cyan size="small" icon={<PlusOutlined />}>
                                                Tomar combo
                                            </ButtonItem>
                                        </Popconfirm>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </>
        );
    }
}

export default PlanEmpresa;
